import { required, email, helpers } from "@vuelidate/validators";
import forEach from "./validators";

const phone = helpers.withMessage(
  "Este campo debe ser un número de teléfono válido",
  (value) => /^(\+?\d{1,3}[-.\s]?)?\d{10}$/.test(value)
);

export default {
  methods: {
    attachValidations(validations) {
      let rules = {}

      validations.forEach((rule) => {
        if (rule === "required") {
          rules.required = helpers.withMessage(
            "Este campo es obligatorio",
            required
          );
        }
        if (rule === "email") {
          rules.email = helpers.withMessage(
            "Este campo debe ser un correo válido",
            email
          );
        }

        if (rule === "phone") {
          rules.phone = helpers.withMessage(
            "Este campo debe ser un número de teléfono válido",
            phone
          );
        }
      });

      return rules
    },

    // Method to handle array validations
    attachArrayValidations(validations) {
      // Apply the same validations for each item in the array
      return {
        // $each: forEach({ email }),
        $each: forEach(this.attachValidations(validations)),
      };
    },

    // Method to generate validation rules dynamically based on field type
    generateValidationRules(field) {
      let rules = {};

      // If the field is an array, apply array validations
      if (field.is_array) {
        rules = this.attachArrayValidations(field.validations);
      } else {
        // Otherwise, apply the normal validations
        rules = this.attachValidations(field.validations);
      }

      return rules;
    }
  }
}